import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IImportProgress } from '@api'
import { ImportProgressFragment } from '@api/fragments'

export default function progress(
  id: string
): Promise<{ status: string; progress: IImportProgress }> {
  return client.gql
    .query({ query, variables: { id } })
    .then(
      ({ data: { node } }: { data: { node: { status: string; progress: IImportProgress } } }) =>
        node
    )
}

const query = gql`
  query employeeImportProgress($id: ID!) {
    node(id: $id) {
      ... on EmployeeImport {
        status
        progress {
          ...ImportProgressFragment
        }
      }
    }
  }
  ${ImportProgressFragment}
`
